// extracted by mini-css-extract-plugin
export var text = "_4v-0";